import getDOMroot from '@/utils/getDOMroot';
import cart from '@/constants/cart';
/* 
import V1cart from '@/utils/V1cart'


需求文档：https://doc.weixin.qq.com/sheet/e3_AUAArwZEAN45ZQDm8GdTBKNVQqV0Q?scode=AB8AVgfuAAcdsN2SlAAagARQb-AAc&tab=3xj9kg

https://developer.mozilla.org/zh-CN/docs/Web/API/Element/getAttribute
https://developer.mozilla.org/zh-CN/docs/Learn/HTML/Howto/Use_data_attributes
*/

/* 
將渠道第一時間存貯到本地

channel
- 还有一个点，就是有效期不需要做计算，每次用户重新进入，都是从头计时，比如：有效期还剩10天，用户又从source=ppc进入，有效期还是30天。
- 0. 嵌入页有source来源就是PPC,其他都是seo，且source保留有效期为30天，30天之后就是source来源都是seo
1. 页面刷新会保留source（已完成）
- 通过首次进页面后query中获取source判断
存在sessionStorage中
*/
let toolsSource = 'item_source';
(function () {
  const urlParams = new URLSearchParams(window.location.search);
  console.log('__channel__', urlParams.get('source'), toolsSource);
  let __now = new Date().getTime();

  if (urlParams.has('source')) {
    // 地址欄帶着source..
    // 記低嘓刻。。
    window.localStorage.__channel__time = __now;

    localStorage.setItem(toolsSource, 'ppc');
  } else {
    if (!localStorage.getItem(toolsSource)) {
      localStorage.setItem(toolsSource, 'seo');
    }
  }

  // 2.時間
  let __channel__time = window.localStorage.__channel__time;
  if (!__channel__time) {
    console.warn('__channel__time is invalid', __channel__time);
    return;
  }

  // let __now=Date.now()
  let ItIs30daysPass =
    (__now - __channel__time) * (1 / 1e3) * (1 / 60) * (1 / 60) * (1 / 24) > 30;
  console.log('ItIs30daysPass', ItIs30daysPass, __channel__time);
  if (ItIs30daysPass) {
    localStorage.setItem(toolsSource, 'seo');
  }
})();

let V1cart = (URLcart, ispurchase) => {
  console.log('V1cart', URLcart);

  let result = URLcart;

  // let SP=new URLSearchParams(window.location.search)
  // let work=SP.get('work')
  let work = getDOMroot().getAttribute('work');
  if (!work) {
    console.warn('work is invalid', work);
    return result;
  }
  let lang = getDOMroot().getAttribute('lang') || 'en';

  let __findFunc = cart.func.find(
    (v) => v.work.trim().toLowerCase() === work.trim().toLowerCase()
  );
  if (!__findFunc) {
    console.warn('__findFunc is invalid', __findFunc, work);
  }
  let func = __findFunc?.func || '0';

  // 1,2,5,8
  let reason = window.sessionStorage.reason || '0';
  let __findHost = cart.host.find(
    (v) => v.lang.trim().toLowerCase() === lang.trim().toLowerCase()
  );
  let host = __findHost?.host || '1';
  let platform = cart.platform[window.userClient.platform] || '5';
  // 套餐 年月周
  let cycle = window.sessionStorage.cycle || '2';
  let ab = '0Z';
  let channel = window.localStorage.getItem(toolsSource);
  let discount = '0';

  console.log('---platform---', platform, window.userClient.platform);
  let track = {
    type: '4',
    sid: '116',
    func: func,
    reason: reason,
    host: host,
    platform: platform,
    cycle: cycle,
    ab: ab,
    channel: channel,
    discount: discount,
  };
  if (!ispurchase) {
    // let __s=Object.keys(track).sort().map(v=>{
    let __s = Object.keys(track)
      .map((v) => {
        return `track[${v}]=${track[v]}`;
      })
      .join('&');
    result = `${result}&${__s}`;

    console.log(
      '%c== V1cart 购买链接传参-HitPaw Online ==',
      'font-size:20px;color:crimson;',
      result
    );
    console.log(track);
    return result;
  } else {
    return track;
  }
};

export default V1cart;
